// GAVION booking: the PublicBookingApi of the public pages: the fake over FakeRest when the app runs on the demo
// dataProvider (the demo build, or any test that mounts DemoApp), gavion-booking otherwise (plan D19, review M10).
import { DataProviderContext } from "ra-core";
import { useContext, useMemo } from "react";
import { dataProviderStore } from "../../../dialer/api/recordStore";
import { IS_DEMO } from "../../../env";
import { createFakePublicBookingApi } from "./fakePublicBookingApi";
import { createHttpPublicBookingApi } from "./httpPublicBookingApi";
import type { PublicBookingApi } from "./types";

export const bookingFunctionUrl = (): string =>
  `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/gavion-booking`;

/** The FakeRest data provider flags itself (providers/fakerest/dataProvider.ts); the Supabase one never does. */
export const isFakeRestProvider = (dp: unknown): boolean =>
  (dp as { isFakeRest?: boolean } | null)?.isFakeRest === true;

export function usePublicBookingApi(isDemo?: boolean): PublicBookingApi {
  // The raw provider, not useDataProvider(): that hook returns a Proxy that answers every property (the flag would never
  // read true) and is a new object on every render (the API, and with it the pages' fetches, would restart in a loop).
  const dp = useContext(DataProviderContext);
  const demo = isDemo ?? (IS_DEMO || isFakeRestProvider(dp));
  return useMemo(
    () =>
      demo && dp
        ? createFakePublicBookingApi({ store: dataProviderStore(dp) })
        : createHttpPublicBookingApi(bookingFunctionUrl()),
    [dp, demo],
  );
}
